import React from 'react';
import { MetaLabel } from './MetaLabel';
interface ScreenHeaderProps {
  eyebrow: string;
  title: string;
  meta?: string;
  action?: React.ReactNode;
}

/**
 * Reworked 9 Sep 2026: the title here used to be set in Archivo
 * semibold — a heavy, blocky display face — while Today's header (the
 * screen Tom explicitly likes) sets its big title in Jost light. Sitting
 * one tab apart, the two read as different apps. This now uses the exact
 * same face/size/weight as Today's `<h1>` so every screen's headline
 * shares one voice — see Today.tsx for the sibling copy of this style.
 */
export function ScreenHeader({
  eyebrow,
  title,
  meta,
  action
}: ScreenHeaderProps) {
  return <header className="sticky top-0 z-20 border-b border-line bg-ink/90 px-5 pb-4 pt-5 backdrop-blur-md" data-id="element-47" data-mp="3nc61wealadc">
      <div className="flex items-start justify-between gap-4" data-id="element-48" data-mp="32dvxz5cznlb1">
        <div className="min-w-0 flex-1" data-id="element-49" data-mp="32bjgsuf21ez1">
          <MetaLabel tone="dim" data-id="element-50" data-mp="37c72d0kil3lv">{eyebrow}</MetaLabel>
          <h1 className="mt-1 truncate text-[28px] font-light leading-[1.05] text-fg" style={{
          fontFamily: "'Jost', 'Helvetica Neue', Arial, sans-serif",
          letterSpacing: '-0.01em'
        }} data-id="element-51" data-mp="37am9rghrfuqn">
            {title}
          </h1>
        </div>
        {action}
      </div>
      {meta ? <p className="mt-3 text-[13px] leading-snug text-muted" data-id="element-52" data-mp="1gqr2wg5s7smq">{meta}</p> : null}
    </header>;
}